<template>
    <div>
<v-toolbar flat color="white">
    <v-tabs v-model="tab">
         <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab>Packages</v-tab>
        <v-tab>Categories</v-tab>
        <v-tab>Promotions</v-tab>
    </v-tabs>
   
</v-toolbar>
 <div v-if="tab==0">
        <packagesFno />
    </div>
    <div v-else-if="tab==1">
        <packagesFnoCat />
    </div>
    <div v-else-if="tab==2">
        <promotions />
    </div>
    </div>
</template>
<script>
import packagesFno from '../components/PackagesFno.vue'
import packagesFnoCat from '../components/PackagesFnoCats.vue'
import promotions from '../components/Promotions.vue'


export default {
    components: {
        packagesFno,
        packagesFnoCat,
promotions
    },
    data(){
        return {
            tab: 0
        }
    }
    
}
</script>